<template>
	<div class="artwork-modal">

		<!-- header -->
		<div class="artwork-modal-header">
			<div class="container">
				<div class="row">
					<div class="col col-xl-6 d-flex flex-column justify-content-center">
						<h2 class="artwork-modal-title">{{ artworkTitle }}</h2>
						<p class="artwork-modal-subtitle"> by {{ artworkArtist }}</p>
					</div>
					<div class="col d-flex align-items-center justify-content-end">
						<button @click="closeModal" type="button" class="btn btn-primary">
							<i class="fal fa-lg fa-times"></i>
							Close
						</button>
					</div>
				</div>
			</div>
		</div>
		<!-- end header -->

		<!-- loading spinner -->
		<loading-spinner class="mt-20" v-if="isLoading"></loading-spinner>

		<!-- body -->
		<div class="artwork-modal-body" v-if="!isLoading">

			<div class="container">
				<!-- artwork display -->
				<div class="row" v-if="artwork">
					<!-- LEFT COLUMN -->
					<div class="col-12 col-xl-6  mb-12 mb-xl-0">
						<div class="row">
							<!-- images -->
							<div class="col" v-for="(image, index) in artwork.images" :key="image">
								<img :src="image.thumbnail" @click="showLightbox(index)">
							</div>
						</div>

						<!-- Review form -->
						<artwork-review-form @saved="onReviewSaved()" :artwork="artwork"></artwork-review-form>


						<!-- Reviews -->
						<artwork-reviews :artwork="artwork"></artwork-reviews>
					</div>

					<!-- RIGHT COLUMN (artwork details) -->
					<div class="col">
						<artwork-artist-details :artwork="artwork" :showSensitive="true"></artwork-artist-details>

						<hr>

						<artwork-details :artwork="artwork"></artwork-details>
					</div>
				</div>
				<!-- end artwork display -->

				<!-- no artwork to display-->
				<div class="row" v-else>
					<div class="col-12">
						<p class="text-center">
							No artwork found.
						</p>
					</div>
				</div>
				<!-- end no artwork-->

				<!-- error -->
				<div class="row" v-if="isError">
					<div class="col-12">
						<p class="text-center">
							<i class="fas fa-exclamation-triangle text-danger"></i>
							An error occurred or your security token has expired.<br>
							Please <a :href="loginPage">return to the login page</a>.
						</p>
					</div>
				</div>
				<!-- end error -->

				<!-- lightbox -->
				<vue-easy-lightbox
					:visible="lightboxVisible"
					:imgs="lightboxImages"
					:index="lightboxIndex"
					@hide="hideLightbox"
				></vue-easy-lightbox>
				<!-- end lightbox -->
			</div>
		</div>
	</div>
</template>

<script>
import ArtworkReviews from './ArtworkReviews.vue';
import ArtworkReviewForm from './ArtworkReviewForm.vue';
import ArtworkDetails from './ArtworkDetails.vue';
import ArtworkArtistDetails from './ArtworkArtistDetails.vue';
import LoadingSpinner from './LoadingSpinner.vue';
import { hide } from '@popperjs/core';

export default {
	emit: ['close'],

	components: {
		ArtworkReviews,
		ArtworkReviewForm,
		ArtworkDetails,
		ArtworkArtistDetails,
		LoadingSpinner
	},

	props: {
		artworkId: {
			type: Number,
			required: true
		}
	},

	data() {
		return {
			isLoading: false,
			isError: false,
			artwork: null,
			lightboxVisible: false,
			lightboxImages: [],
			lightboxIndex: 0
		}
	},

	mounted() {
		this.getArtwork(this.artworkId);
		document.body.style.overflow = 'hidden';
	},

	beforeUnmount() {
		document.body.style.overflow = 'auto';
	},

	computed: {
		artworkTitle() {
			if(this.artwork) {
				return this.artwork.title.replaceAll('&quot;', '"');
			}

			return 'Artwork';
		},
		artworkArtist() {
			return this.artwork ? this.artwork.artist : 'Artist';
		},
		artworkCategory() {
			return this.artwork ? this.artwork.category.name : 'Category';
		},
	},

	methods: {
		/**
		 * Retrieve single artwork from API
		 */
		getArtwork() {
			this.isLoading = true;
			this.isError = false;

			this.$store.dispatch('getArtwork', { id: this.artworkId })
				.then(response => {
					this.artwork = response.data;
					this.fillLightboxImages();
				})
				.catch(error => {
					console.error(error);
					this.isError = true;
				})
				.finally(() => {
					this.isLoading = false;
				});
		},

		onReviewSaved() {
			this.getArtwork();
			// set the 'refresh pending' state on the store
			this.$store.commit('setRefreshPending', true);
		},

		/**
		 * Get display properties for single image gallery
		 * @param {*} image
		 */
		getImageProperties(image) {
			return {
				imageUrl: image.large,
				withDownload: false,
				animation: 'blur'
			};
		},

		/**
		 * Close modal
		 */
		closeModal() {
			this.$emit('close');
			document.body.style.overflow = 'auto';
			this.$router.push({ name: 'index' });
		},

		fillLightboxImages() {
			this.lightboxImages = this.artwork.images.map(image => {
				return {
					// src: image.large,
					src: image.full,
					title: this.artwork.title
				};
			});
		},

		/**
		 * Show lightbox
		 * @param {number} index
		 */
		showLightbox(index) {
			this.lightboxIndex = index;
			this.lightboxVisible = true;
		},

		/**
		 * Hide lightbox
		 */
		hideLightbox() {
			this.lightboxVisible = false;
		}
	}
}
</script>